import React, { useState, useEffect } from "react";
import googleIcon from "./../assets/google_icon.svg";
import emailIcon from "./../assets/Email.svg"
import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import logo from "./../assets/logo.svg";
import backgroundAI from "./../assets/background_page_new.svg";
import magically from "./../assets/main_login_header.svg";
import magicallyBig from "./../assets/magically_big.svg";
import { deleteCookie, deleteCookiesLoginUser, setCookie } from "../commonUtils";
import Loginpage from "./Loginpage";
/*istanbul ignore next*/
const Login = ({ setUser, setIsLoggedIn }) => {
  const navigate = useNavigate();
  const [errorState, setErrorState] = useState(false);
  const [googleAccessToken, setGoogleAccessToken] = useState(null);
  const [hide, setHide] = useState(false);
  const [index, setIndex] = useState(0);
  const [emailLogin, setEmailLogin] = useState(false);

  const paragraphs = [
    "Accessibility Services with MagicA11y Elevating Coverage with Triple Win Savings, Accuracy, Consistency Magic is committed to humanity’s pursuit of happiness by making lifelong digital learning accessible, affordable and sustainable.",
  ];

  useEffect(() => {
    const animate = () => {
      setHide(true);
      setTimeout(() => {
        setIndex((prevIndex) => (prevIndex + 1) % paragraphs.length);
        setHide(false);
      }, 4000);
    };
    const interval = setInterval(animate, 3000);
    return () => clearInterval(interval);
  }, []);

  const loginWithGoogle = (accessToken) => {
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/identity-api/api/v1/users/googleLogin?access_token=${accessToken}`
      )
      .then((response) => {
        deleteCookiesLoginUser();
        const bearerToken = `Bearer ${response.data.token}`;
        setCookie("authToken", bearerToken);
        setCookie("username", response.data.user.firstName)
        setCookie("email", response.data.user.email)
        setCookie("User", JSON.stringify(response.data.user));
        setUser(response.data.user);
        setIsLoggedIn(true);
        navigate("/home", { replace: true });
      })
      .catch((err) => {
        setErrorState(true);
        // localStorage.removeItem("google_access_token");
        deleteCookie("google_access_token")
        console.log(err);
        setIsLoggedIn(false);
      });
  };

  const handleLoginWithGoogle = useGoogleLogin({
    onSuccess: (codeResponse) => {
      setCookie("google_access_token", codeResponse.access_token, {expires: 1})
      loginWithGoogle(codeResponse.access_token);
      setGoogleAccessToken(codeResponse.access_token);
    },
    onError: (error) => {
      console.log("Login Failed:", error);
      setErrorState(true);
    },
  });

  const handleLoginWithEmail = () => {
    setEmailLogin(true);
  };

  useEffect(() => {
    const originalBodyStyle = document.body.style.cssText;
    const handleMouseEnter = () =>
      document.body.classList.add("body-background-hover");
    const handleMouseLeave = () =>
      document.body.classList.remove("body-background-hover");
    document.body.style.background = `url(${backgroundAI}) no-repeat top left`;
    document.body.style.backgroundSize = "cover";
    document.body.style.backgroundPositionY = "20px";
    document.body.style.transition = "background-position 0.5s ease";
    document.body.addEventListener("mouseenter", handleMouseEnter);
    document.body.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      document.body.style.cssText = originalBodyStyle;
      document.body.removeEventListener("mouseenter", handleMouseEnter);
      document.body.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  const handleHome = () => {
    navigate("/login", { replace: true });
    setEmailLogin(false);
  };

  return (
    <>
      <div class="login-header">
        <div class="logo">
          <img
            src={logo}
            alt="Accelerators"
            onClick={handleHome}
            style={{ cursor: "pointer" }}
          />
        </div>
      </div>
      <div class="outer-login">
      <img src={magicallyBig} style={{maxHeight:'480px'}} alt="Magica11y"/>

     
      <div className="button-container">
      {!emailLogin && ( <img src={magically} alt="Magica11y" style={{maxWidth:'520px',marginBottom:'0'}}/>)}
        {/* <div className="border"></div> */}
        {!emailLogin && (
          <div style={{position:'relative',top:'-40px',zIndex:'999'}}>
            {/* <div className="container-para">
              <p className={`paragraph ${hide ? "hide" : ""}`}>
                {paragraphs[index]}
              </p>
            </div> */}
            <div className="buttons">
              { <button
                className="buttonTwo"
                onClick={() => handleLoginWithGoogle()}
              >
                <img src={googleIcon} alt="Google" /> Login with Google
              </button> }
              <button
                className="buttonTwo"
                onClick={() => handleLoginWithEmail()}
              >
                <img src={emailIcon} alt="Email" style={{marginRight: "10px"}}/> 
                Login with Email
              </button>
            </div>
            {errorState && (
              <div className="error-msg">Your account does not exist.</div>
            )}
          </div>
        )}
        {emailLogin && (
          <Loginpage
            handleLoginWithGoogle={handleLoginWithGoogle}
            errorState={errorState}
            setUser={setUser} 
            setIsLoggedIn = {setIsLoggedIn} 
          />
        )}
      </div>
      </div>
    </>
  );
};

export default Login;
